import { BitfStrapiEnvelopeMapper } from '@common/libs/bitforce/core/parsers/strapi-parser';

export class AppEnvelopeMapper extends BitfStrapiEnvelopeMapper {}
